import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Callout, Column, Row, TextButton } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ClientContactPicker } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/ClientRecipients/ClientContactPicker/ClientContactPicker';
import { signatoryPromotionOf } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/ClientRecipients/ClientRecipients.utils';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { contactRoleTextsPath } from '~/utils/contact-role-labels';
import { useMainSignatorySelection } from './hooks/useMainSignatorySelection';
export const GetMainSignatoryModalContentTID = (parentTestId)=>getTestIds(parentTestId);
export function MainSignatoryModalContent(param) {
    let { draft, setDraft, testId } = param;
    const { MainSignatoryModalContentTestIds: TID } = useMemo(()=>GetMainSignatoryModalContentTID(testId), [
        testId
    ]);
    const { t: contactDetailsTexts } = useLocaleKeys('proposal.studio.contactDetails');
    const { t: contactRoleTexts } = useLocaleKeys(contactRoleTextsPath);
    const { CRM_CONTACTS } = useFeatureFlags();
    const showContactRoles = CRM_CONTACTS === true;
    const { contacts, isLoading, signatory, onSelectContact, onCreateContact, onEditContact } = useMainSignatorySelection(draft, setDraft);
    const signatoryPromotion = showContactRoles ? signatoryPromotionOf(signatory, contactRoleTexts) : null;
    const signatoryRow = /*#__PURE__*/ _jsxs(Row, {
        gap: 16,
        alignItems: "center",
        testId: TID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Box, {
                grow: true,
                children: /*#__PURE__*/ _jsx(ClientContactPicker, {
                    testId: TID.ContactPicker(),
                    contacts: contacts,
                    value: signatory,
                    onChange: onSelectContact,
                    onCreateContact: onCreateContact,
                    disabled: isLoading,
                    isLoading: isLoading,
                    fullHeightSheet: false,
                    label: contactDetailsTexts.picker.mainSignatoryLabel(),
                    placeholder: contactDetailsTexts.picker.signatoryPlaceholder(),
                    showContactRoles: showContactRoles
                })
            }),
            signatory != null && /*#__PURE__*/ _jsx(TextButton, {
                testId: TID.EditContact(),
                bi: {
                    name: 'edit_contact'
                },
                onClick: onEditContact,
                children: contactDetailsTexts.editContact()
            })
        ]
    });
    if (signatoryPromotion == null) return signatoryRow;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        children: [
            signatoryRow,
            /*#__PURE__*/ _jsx(Callout, {
                testId: TID.PromotionCallout(),
                children: contactDetailsTexts.picker.signatoryPromotionCallout(signatoryPromotion)
            })
        ]
    });
}
